module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAAM1BMVEX////ljjjyy6755tnsrnvvvZb67OP88+znlkv12cT9+fbqpm300rn338/ttonxxKLonl2ETQroAAAAmUlEQVR4Xu3SxwoDMQxFUT0Vl6n5/68NKMSbWIK03dztQQgs0/+7Wpj3hA+AY92QsSDj2rBqyMuKVmM+AKGQT2CjkDtg9OAyYcVI3+ciHmBSKMyfJeMzY5FCv692ecbzY47mrN4aMXkSMXsW8Oij6Vu2m3HLpjnfrdBkegF6spuBGnNpUDfeDW32ycs4jNFLtpGnqkelb7q6A7RzAyV6ClVRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/pin_apr.png
// module id = 1684
// module chunks = 1